module.exports = __webpack_public_path__ + "static/img/systemli3.9742296.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/systemli3.png
// module id = m2k6
// module chunks = 1